import * as React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import Breadcrumb from 'components/Shared/Breadcrumb'
import CustomBadge from 'components/Shared/Badge'

type Props = {
  ActionButtons?: any
  breadcrumb?: CommonBreadcrumbItems[]
  ParticipantHeader?: any
  title?: string
  subTitle?: string
  Avatar?: any
  isBadgeActive?: boolean
}

const CommonHeader = ({
  ActionButtons = [],
  breadcrumb,
  title,
  subTitle,
  Avatar,
  isBadgeActive = false,
}: Props) => {
  const truncatedTitle: any =
    title && title.length > 43 ? `${title.slice(0, 40)}...` : title
  const TruncatedActionButtons =
    ActionButtons.length > 4 ? ActionButtons.splice(0, 4) : ActionButtons

  const titleComponent = () => {
    return isBadgeActive ? (
      <CustomBadge
        contentType="Header"
        title={truncatedTitle}
        badgeType="New"
      />
    ) : (
      <Typography
        variant="h4"
        sx={{
          margin: '0px',
          wordBreak: 'break-word',
        }}
      >
        {truncatedTitle}
      </Typography>
    )
  }
  return (
    <Grid
      sx={{
        marginTop: {
          xs: '84px',
          sm: '24px',
        },
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1.5rem',
      }}
      item
      xs={12}
      md={12}
    >
      <Box
        sx={{
          display: 'flex',
          gap: '16px 16px',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          alignContent: 'space-around',
          flexDirection: 'row',
        }}
      >
        {breadcrumb && <Breadcrumb items={breadcrumb} />}
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '16px',
            flexDirection: 'row',
          }}
        >
          {TruncatedActionButtons.length > 0 &&
            TruncatedActionButtons.map((ActionButton: any, key: number) => (
              <ActionButton key={key} />
            ))}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          gap: '16px 16px',
          flexWrap: {
            xs: 'wrap',
            sm: 'nowrap',
          },
          justifyContent: 'start',
          alignItems: {
            xs: 'baseline',
            sm: 'end',
          },
          alignContent: 'space-around',
          flexDirection: 'row',
        }}
        gap={2}
      >
        {Avatar && <Avatar sx={{ width: 72, height: 72, alignSelf: 'end' }} />}
        <Box
          sx={{
            flexDirection: {
              xs: 'column',
              sm: 'row',
            },
          }}
        >
          {truncatedTitle && (
            <Box
              gap={1}
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'start',
                alignItems: {
                  xs: 'baseline',
                  sm: 'baseline',
                },
                alignContent: 'space-around',
                flexDirection: 'row',
              }}
            >
              {titleComponent()}
              {subTitle && (
                <Typography
                  variant="body2"
                  color="rgba(0, 0, 0, 0.6)"
                  sx={{
                    margin: '0px',
                    wordBreak: 'break-word',
                  }}
                >
                  {subTitle}
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Grid>
  )
}

export default CommonHeader
